<template>
  <div id="basic">
    <div class="banner_bar">
      <h3>门店类目信息</h3>
      <el-form>
        <div class="bottom_center">
          <el-button
            type="primary"
            class="vubutton"
            :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
            @click="onSubmit"
          >+新建</el-button>
        </div>
        <div style="display:flex">
          <el-form-item label="请选择门店" style="margin-right:20px" v-if="platform !== '1'">
            <el-select v-model="formInline.id" placeholder="请选择" @change="getTableData()">
              <el-option
                v-for="index in typeDate"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外卖堂食">
            <el-select
              v-model="formInline.category_type"
              placeholder="请选择"
              @change="getTableData()"
            >
              <el-option label="堂食" :value="1"></el-option>
              <el-option label="外卖" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>

      <el-table
        :fit="false"
        border
        :data="tableData"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="简介" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.intro }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="180">
          <template slot-scope="scope">
            <img class="el-upload-list__item-thumbnail" style="width:50px;height:50px" :src="scope.row.image" alt />
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" @click="getEdit(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog title="类目信息" :visible.sync="dialogFormVisible_ca">
      <el-form :model="form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>

        <el-form-item label="创建时间" :label-width="formLabelWidth" v-if="form.getEdit">
          <el-input v-model="form.created_at" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" :label-width="formLabelWidth" v-if="form.getEdit">
          <el-input v-model="form.updated_at" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="图片" :label-width="formLabelWidth">
          <el-upload
            :action="'https://upload-z2.qiniup.com'"
            list-type="picture-card"
            :auto-upload="true"
            :file-list="fileList"
            :on-success="topSuccess"
            :on-error="topSuccess"
            :before-upload="QiniuToken"
            :data="QiniuData"
            :limit="1"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  v-if="!form.getEdit"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!form.getEdit"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="简介" :label-width="formLabelWidth">
          <el-input v-model="form.intro" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="堂食外卖" :label-width="formLabelWidth">
          <el-select v-model="form.c_type" placeholder="请选择" :disabled="form.getEdit">
            <el-option label="堂食" :value="1"></el-option>
            <el-option label="外卖" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺编号" :label-width="formLabelWidth" v-if="form.getEdit">
          <el-input v-model="form.shop_id" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus()">取 消</el-button>
        <el-button type="primary" @click="statusStore()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';
export default {
  data() {
    return {
      platform: '',
      tableData: [],
      typeDate: [],
      datalist: [],
      parentid: null,
      formInline: {
        id: '',
        category_type: 1, // c_type|| 2外卖  1堂食
      },
      total: 0,
      page_no: 0,
      dialogFormVisible_ca: false,
      form: {
        name: '',
        c_type: 1,
      },
      formLabelWidth: '120px',
      putStatus: false,
      fileList: [],

      QiniuData: {
        // key: '', //图片名字处理
        token: '', //七牛云token
      },
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  methods: {
    pageSize(index) {
      this.page_no = index;
      this.getTableData();
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    // 获取列表
    getTableData() {
      let data = {
        parent_id: 0,
        shop_id: this.formInline.id,
        menu_id: 0,
        category_type: this.formInline.category_type,
      };

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_cuisines_platform
      } else {
        baseUrl = this.$userList.user_menu_cuisines
      }
      const url = baseUrl + '/' + this.page_no + '/10';

      this.$http.get(url, data).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.items.map(items => {
            items.created_at = fecha.format(
              new Date(items.created_at),
              'yyyy-MM-dd HH:mm:ss'
            );
            items.updated_at = fecha.format(
              new Date(items.updated_at),
              'yyyy-MM-dd HH:mm:ss'
            );
            return items;
          });
          this.total = res.data.count;
          if (!this.tableData.length && this.page_no !== 0) {
            this.page_no = 0;
            this.getTableData();
          }
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //详细信息
    getEdit(index, row) {
      // this.putStatus = true;

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_cuisines_list_platform
      } else {
        baseUrl = this.$userList.user_menu_cuisines_list
      }

      const url = baseUrl + '/' + row.id;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          res.data.getEdit = true;
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          this.fileList = [{ url: res.data.image }];
          this.form = res.data;
          this.dialogFormVisible_ca = true;
          this.putStatus = true;
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取详细信息失败');
        }
      });
      console.log(index, row);
    },
    //打开编辑弹窗
    handleEdit(index, row) {
      this.dialogFormVisible_ca = true;
      this.putStatus = true;
      this.form = row;
      this.fileList = [{ url: row.image }];
      console.log(index, row);
    },
    //删除
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm('此操作将删除类目, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {

        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_menu_cuisines_list_platform
        } else {
          baseUrl = this.$userList.user_menu_cuisines_list
        }

        const url = baseUrl + '/' + row.id;

        this.$http.delete(url).then(res => {
          if (res.code === 200) {
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除类目失败');
          }
        });
      });
    },
    // 取消
    noStatus() {
      this.dialogFormVisible_ca = false;
      if (this.form.getEdit || !this.putStatus) {
        return;
      }
    },
    setForm() {
      this.form = {
        name: '',
        c_type: 1,
      };
      this.fileList = [];
    },
    onSubmit() {
      this.dialogFormVisible_ca = true;
      this.putStatus = false;
      this.setForm();
    },
    statusStore() {
      if (this.form.getEdit) {
        this.dialogFormVisible_ca = false;
        return;
      }
      if (!this.putStatus) {
        this.setStore();
      } else {
        this.putDtore();
      }
    },
    testData(data) {
      let test = true;
      for (let index in data) {
        if ((!data[index] && data[index] !== 0) || data[index] === null) {
          test = false;
        }
      }
      return test;
    },
    setStore() {
      console.log(this.form);

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_cuisines_list_platform
      } else {
        baseUrl = this.$userList.user_menu_cuisines_list
      }

      const datas = {
        name: this.form.name,
        intro: this.form.intro,
        image: (this.fileList.length && this.fileList[0].url) || '',
        c_type: this.form.c_type,
        shop_id: this.formInline.id,
        order_seq: 23,
        parent_id: 0,
      };
      if (!this.testData(datas)) {
        this.$alert('类目信息不能为空');
        return;
      }
      this.$http.post(baseUrl, datas).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible_ca = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('新增类目失败');
        }
        console.log(res);
      });
    },
    putDtore() {
      const data = {
        id: this.form.id,
        name: this.form.name,
        image: (this.fileList.length && this.fileList[0].url) || '',
        intro: this.form.intro,
        c_type: this.form.c_type,
        order_seq: this.form.order_seq,
      };
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_cuisines_list_platform
      } else {
        baseUrl = this.$userList.user_menu_cuisines_list
      }

      this.$http.put(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible_ca = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('修改类目失败');
        }
      });
    },
    // 七牛
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    topSuccess(event, file, fileList) {
      console.log('file success')
      this.fileList = fileList.map(item => {
        if (item.response) {
          item.name = item.response.hash;
          item.url = this.QiniuData.url_prefix + '/' + item.response.hash;
        }
        return item;
      });
    },
    async QiniuToken() {
      console.log('qiniu token')
      const url = this.$userList.user_status_qiniutoken_dish;
      const data = await this.$http.get(url).then(res => {
        return res;
      });
      if (data.code === 200 && data.data.up_token) {
        this.QiniuData.token = data.data.up_token;
        this.QiniuData.url_prefix = data.data.url_prefix;
        return true;
      } else {
        return false;
      }
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => {
        if (item.name !== file.name) {
          return item;
        }
      });
      console.log(file);
    },
  },
  created() {
    this.$root.setheadName();
    this.getType();
    let platform = this.$route.query.platform
    console.log("platform is :", platform)
    this.platform = platform
  },
};
</script>

<style >
#basic {
  width: 100%;
  height: auto;
  position: relative;
}
.banner_bar {
  width: 100%;
  height: auto;
  background: #fff;
  min-height: 800px;
  box-sizing: border-box;
  padding: 20px;
}
.top_button {
  width: 100%;
  min-height: 300px;
  display: flex;
}
.button_a {
  width: 300px;
  height: auto;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-right: 50px;
  margin-bottom: 50px;
}
.button_top {
  width: 100%;
  height: 64px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
}
.button_push {
  width: 63px;
  height: 32px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  line-height: 32px;
  border-radius: 10px;
}
.banner_ul {
  width: 100%;
  height: auto;
}
.banner_ul li {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 40px;
}
.li_icon i {
  margin-right: 10px;
  width: 16rpx !important;
  height: 16rpx !important;
}
.colorli {
  background: rgba(127, 125, 243, 0.3);
}
.bottoms {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  height: 100%;
  height: 20px;
}
</style>
